import React from "react";
import { useFormContext } from "react-hook-form";
import HiddenComponent from "@common/components/shared/forms/HiddenComponent";
import useLogin from "@common/components/hooks/useLogin";

export const StandardHiddenInputs = () => {
  const [{ siteGuid }] = useLogin();

  const methods = useFormContext();
  const { register } = methods;
  return (
    <>
      <input type="hidden" name="guid" value={siteGuid} />
      <HiddenComponent name="id" register={register} />
      <HiddenComponent name="rowVersion" register={register} />
    </>
  );
};

export default StandardHiddenInputs;
